export const PROMO_MODAL_DISMISS_KEY = 'promoAnnouncementDismissedAt'
export const PROMO_MODAL_DISMISS_DURATION_MS = 24 * 60 * 60 * 1000
